// export const BUSINESS_INFO_INIT = 'BUSINESS_INFO_INIT'
export const BUSINESS_INFO = 'BUSINESS_INFO'
export const BUSINESS_INFO_DATA = 'BUSINESS_INFO_DATA'
export const BUSINESS_INFO_UPDATE = 'BUSINESS_INFO_UPDATE'
// export const BUSINESS_INFO_ADD = 'BUSINESS_INFO_ADD'
// export const BUSINESS_INFO_DELETE = 'BUSINESS_INFO_DELETE'
export const BUSINESS_INFO_SUCCESS = 'BUSINESS_INFO_SUCCESS'
export const BUSINESS_INFO_FAIL = 'BUSINESS_INFO_FAIL'
export const BUSINESS_INFO_FORM = 'BUSINESS_INFO_FORM'
export const BUSINESS_INFO_FORM_DATA = 'BUSINESS_INFO_FORM_DATA'